import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { AtomAsyncDataComponent } from './atom-async-data.component';

@NgModule({
    imports: [CommonModule, WdxSpinnerModule, TranslateTokenisedStringPipe],
    declarations: [AtomAsyncDataComponent],
    exports: [AtomAsyncDataComponent],
})
export class AtomAsyncDataModule {}
